import {bootstrapModule} from 'src/utilities/vuex'
import Vue from 'vue'
import Constants from 'src/utilities/constants'
import axios from 'axios'
import {objectById, objectByName} from 'src/utilities/utils'
import {ObjectID} from 'bson'
import _ from 'lodash'
import {addHeaders} from 'src/utilities/authHeader'

let initialState = {
  edit: {
    id: null,
    entity: null,
    entityId: null,
    name: null,
    value: null,
    locked: false,
    active: true,
    createdAt: null,
    updatedAt: null
  },
  metadata: {}
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const _metadataStore = {
  namespaced: true,
  state,
  getters: {
    byEntity: (state) => (entity) => {
      if (!state.metadata[entity]) {
        return []
      }
      return state.metadata[entity]
    },
    byEntityActive: (state) => (entity) => {
      if (!state.metadata[entity]) {
        return []
      }
      return _.filter(state.metadata[entity], (metadatum) => metadatum.active)
    },
    putPayload (state) {
      if (!state.edit.id) {
        state.edit.id = new ObjectID().toString()
      }
      return JSON.parse(JSON.stringify({
        id: state.edit.id,
        endpoint: 'metadata',
        data: state.edit
      }))
    },
    nameExists: (state) => (payload) => {
      if (state.metadata[payload.entity]) {
        const found = objectByName(state.metadata[payload.entity], payload.name)
        if (found === undefined || found.id === state.edit.id) {
          return false
        }
      }
      return true
    }
  },
  mutations: {
    reset (state, payload) {
      for (let f in state) {
        Vue.set(state, f, initialState[f])
      }
    },
    resetEdit (state, payload) {
      state.edit = JSON.parse(JSON.stringify(initialState.edit))
    },
    entity (state, payload) {
      state.metadata[payload.entity] = payload.data
    },
    updateMetadatum (state, payload) {
      if (!state.metadata[payload.entity]) {
        state.metadata[payload.entity] = []
      }
      const existingMetadatum = objectById(state.metadata[payload.entity], payload.data.id)
      if (existingMetadatum) {
        existingMetadatum.name = payload.data.name
        existingMetadatum.value = payload.data.value
        existingMetadatum.locked = payload.data.locked
        existingMetadatum.active = payload.data.active
      } else {
        state.metadata[payload.entity].push(payload.data)
      }
    },
    delete (state, payload) {
      state.metadata[payload.entity] = _.filter(state.metadata[payload.entity], (metadatum) => metadatum.id !== payload.data.id)
    }
  },
  actions: {
    async fetchByEntityAndEntityId ({ commit }, payload) {
      try {
        let url = process.env.VUE_APP_PTRAC_API_URI + '/metadata/search/findByEntityId?entityId=' + payload.entityId
        const response = await axios.get(url, Constants.HEADERS.DEFAULT)
        commit('entity', {entity: payload.entity, data: response.data._embedded.metadata})

        return {
          result: Constants.RETURN_CODES.SUCCESS
        }
      } catch (err) {
        return {
          result: Constants.RETURN_CODES.ERROR,
          message: err
        }
      }
    },
    async delete ({ commit }, payload) {
      const url = process.env.VUE_APP_PTRAC_API_URI + '/metadata/' + payload.data.id

      try {
        await axios.delete(url, { headers: await addHeaders()})
        commit('delete', payload)
        return {
          result: Constants.RETURN_CODES.SUCCESS
        }
      } catch (err) {
        return {
          result: Constants.RETURN_CODES.ERROR,
          message: err
        }
      }
    }
  }
}

export {_metadataStore}

export default bootstrapModule(_metadataStore)
